import { AxiosPromise } from 'axios';
import { http } from 'services';
import type {
  RecommendedTemplatesResponse,
  TemplateDetail,
  TemplateLanguage,
  TemplateListParams,
  TemplateListResponse,
  TemplateSummary,
  UseTemplateResult,
} from './types';

// The catalogue is global; org context (and the TESTS_CREATE check) rides the X-Organization-Id header.
export const List = (params: TemplateListParams): AxiosPromise<TemplateListResponse> =>
  http.request.get('/api/test-templates', { params });

export const Recommended = (params: { language?: TemplateLanguage; limit?: number }): AxiosPromise<RecommendedTemplatesResponse> =>
  http.request.get('/api/test-templates/recommended', { params });

export const Get = (id: string): AxiosPromise<TemplateDetail> =>
  http.request.get(`/api/test-templates/${encodeURIComponent(id)}`);

export const Use = (id: string, data: { title?: string }): AxiosPromise<UseTemplateResult> =>
  http.request.post(`/api/test-templates/${encodeURIComponent(id)}/use`, data);

export const Adapt = (
  id: string,
  data: { topic: string; title?: string; difficulty?: 'easy' | 'medium' | 'hard' },
): AxiosPromise<UseTemplateResult> => http.request.post(`/api/test-templates/${encodeURIComponent(id)}/adapt`, data);

export const SaveOrgTemplate = (data: { testId: string; title?: string; description?: string }): AxiosPromise<TemplateSummary> =>
  http.request.post('/api/test-templates/org', data);

export const DeleteTemplate = (id: string): AxiosPromise<void> =>
  http.request.delete(`/api/test-templates/${encodeURIComponent(id)}`);
